var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11445_76158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.92188C4.55094 3.92188 3.64076 4.29889 2.96967 4.96997L1.9723 5.96734L1.96962 5.97001L1.96695 5.97269L-7.53033 15.47C-7.67098 15.6106 -7.75 15.8014 -7.75 16.0003V20.0003C-7.75 20.4145 -7.41421 20.7503 -7 20.7503H-3C-2.80109 20.7503 -2.61032 20.6713 -2.46967 20.5306L8.03033 10.0306C8.70142 9.35955 9.07843 8.44936 9.07843 7.5003C9.07843 6.55124 8.70142 5.64106 8.03033 4.96997C7.35924 4.29889 6.44906 3.92188 5.5 3.92188ZM6.49995 9.43969L6.96967 8.96997C7.35945 8.58019 7.57843 8.05154 7.57843 7.5003C7.57843 6.94907 7.35945 6.42041 6.96967 6.03063C6.57989 5.64085 6.05123 5.42187 5.5 5.42187C4.94877 5.42187 4.42011 5.64085 4.03033 6.03063L3.56062 6.50035L6.49995 9.43969ZM2.49996 7.56101L5.43929 10.5003L-3.31066 19.2503H-6.25V16.311L2.49996 7.56101Z",
    fill: "#5B87EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11445_76158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.8b883f0bfce17453addef2659bf30329.svg";
export { ForwardRef as ReactComponent };